
import { Options, Ref, Vue } from "vue-property-decorator";

@Options({
  props: {
    yearsList: Object,
  },
  components: {}
})
export default class MultiSelectFilterYears extends Vue {
  private yearsList!: any[];

  private selectedYears: any[] = [];

  private finalSelectedYears: any[] = [];

  private showMultiSelect = false;

  @Ref('dropDownSelectYears')
  private dropDownSelectUI!: HTMLElement;

  created(): void {
    window.addEventListener('click', this.clickedElement);
  }

  beforeUnmount(): void {
    window.removeEventListener('click', this.clickedElement);
  }

  private clickedElement(e: MouseEvent): void | boolean {
    const el: HTMLElement = this.dropDownSelectUI;
    const rect = el.getBoundingClientRect();
    if (e.pageX >= rect.left && e.pageX <= rect.right && e.pageY >= rect.top && e.pageY <= rect.bottom + this.yearsList.length * 60) {
      return true;
    } else {
      this.showMultiSelect = false;
    }

  }

  mounted(): void {
    // select 'All' by default
    if (this.yearsList.length > 0) {
      for (let i = 0; i < this.yearsList.length; i++) {
        this.selectedYears.push(this.yearsList[i]);
        this.selectedYears[i].selected = true;
      }
      this.finalSelectedYears = this.selectedYears;
      this.$emit('selectYears', this.finalSelectedYears);
    }
  }

  private onSelectedYearsChanged(index: number) {
    this.selectedYears[index].selected = !this.selectedYears[index].selected;

    const allSelected = this.selectedYears.some(item => item.name === 'All' && item.selected);

    if (index === 0) {
      this.selectedYears.slice(1).forEach(item => (item.selected = allSelected));
    }

    this.finalSelectedYears = this.selectedYears.slice(1).filter(item => item.selected);

    if (this.finalSelectedYears.length === this.yearsList.length - 2 && allSelected) {
      this.selectedYears[0].selected = false;
    }

    this.$emit('selectYears', this.finalSelectedYears);
  }


  private toggleMultiSelect() {
    this.showMultiSelect = !this.showMultiSelect;
  }

  get selectedYearsText() {
    if (this.finalSelectedYears.length === 0) {
      return 'No status selected';
    }
    const allSelected = this.selectedYears.some(item => item.name === 'All' && item.selected);
    if (allSelected) {
      return 'All';
    }
    return this.finalSelectedYears.map(item => item.name).join(', ');
  }


}

